import * as React from 'react'
import { Link } from 'react-router'

import { Container, Row, Col } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs, Crumb } from 'components/BreadCrumbs'
import Button from 'components/Button'
import InfoCard from 'components/Cards/InfoCard'
import StickyChannel from 'components/StickyChannel'
import SimpleTable from 'components/Tables/SimpleTable'
import { IVoice } from 'features/Voices/types'
import { dispatchToProps } from './Voice.container'

import cn from 'classnames'
import * as sLay from 'styles/modules/layout.scss'
import * as sMarg from 'styles/modules/margins.scss'
import * as sText from 'components/Text/Text.scss'
import * as sAnim from 'components/Animation/Animation.scss'

export interface IPageVoice {
  voiceId: string
  voice?: IVoice
  loading: boolean
  getVoice: typeof dispatchToProps['getVoice']
  showVoiceCreateModal: typeof dispatchToProps['showVoiceCreateModal']
}

export class Voice extends React.Component<IPageVoice> {
  componentDidMount() {
    const { getVoice, voiceId } = this.props

    if (voiceId !== '7217D10D5DF394292FC9') {
      // prevent `Unauthorized` exception for global VoiceBunny project
      getVoice({ voiceId })
    }
  }
  render() {
    const { voiceId, voice, showVoiceCreateModal } = this.props
    return (
      <Page layout={{ header: 'app' }} title="Actor Recordings">
        <PageHeader>
          <Crumbs title="Actor Recordings">
            <Crumb parent to="/dashboard/voice-actor-recordings">
              List
            </Crumb>
            <Crumb active to={`/dashboard/voice-actor-recordings/${voiceId}`}>
              {voice && voice.id}
            </Crumb>
          </Crumbs>
        </PageHeader>
        <Container paddingTop paddingBottom className={cn('md', sAnim.comeUp)}>
          {voice && (
            <Row className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'], 'md')}>
              <Col className={cn('md', sLay['flex-gt-xs-60'])}>
                <InfoCard title="Details" className={sMarg.mb30to15}>
                  <SimpleTable>
                    <div>
                      <div>Title:</div>
                      <div>{voice.title}</div>
                    </div>
                    {voice.ban !== '20002019' && (
                      <div>
                        <div>Billing Account:</div>
                        <div>
                          <Link to={`/dashboard/billing/accounts/${voice.ban}`}>{voice.ban}</Link>
                        </div>
                      </div>
                    )}
                    <div>
                      <div>Voice actor ID:</div>
                      <div>{voice.talendID}</div>
                    </div>
                  </SimpleTable>
                </InfoCard>
                <InfoCard title="Script" className={sMarg.mb30to15}>
                  {Object.keys(voice.script).map((partName, idx) => (
                    <div
                      key={partName}
                      className={cn({
                        [sMarg.mb30to15]: idx !== Object.keys(voice.script).length - 1,
                      })}
                    >
                      <div className={cn(sText.descrip2, sMarg.mb15)}>{partName}</div>
                      <div className={cn(sText.descrip4)}>{voice.script[partName]}</div>
                    </div>
                  ))}
                </InfoCard>
                {voice.reads.map((read, idx) => (
                  <InfoCard key={idx} title={`Reading ${idx + 1}`} className={sMarg.mb30to15}>
                    {Object.keys(read.urls).map(partName => (
                      <div key={partName} className={sMarg.mb30to15}>
                        <div className={cn(sText.descrip2, sMarg.mb15)}>{partName}</div>
                        <audio controls style={{ width: '100%' }}>
                          <source src={read.urls[partName].default} type="audio/mpeg" />
                        </audio>
                      </div>
                    ))}
                  </InfoCard>
                ))}
              </Col>
              <Col className={cn(sLay['flex-gt-xs-40'], 'md')}>
                <StickyChannel>
                  <div className={sLay['layout-column']}>
                    <Button
                      className={sMarg.mb15}
                      color="tertiary"
                      size="sm"
                      rect
                      onClick={() => showVoiceCreateModal({ talentID: voice.talendID })}
                    >
                      Reorder from Actor
                    </Button>
                  </div>
                </StickyChannel>
              </Col>
            </Row>
          )}
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/Voice/Voice.tsx